import React from 'react';
import { OPENFINANCE_THEME } from '../../constants/openFinanceTheme';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'accent' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  children,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'font-semibold transition-all duration-200 inline-flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed';
  const sizeStyles = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-3 text-base',
    lg: 'px-6 py-4 text-lg'
  };
  const variantStyles = {
    primary: 'text-white shadow-md hover:shadow-lg active:scale-[0.98]',
    secondary: 'bg-white border-2 text-gray-700 hover:bg-gray-50 active:scale-[0.98]',
    accent: 'text-white shadow-md hover:shadow-lg active:scale-[0.98]',
    outline: 'bg-transparent border-2 hover:bg-gray-50 active:scale-[0.98]'
  };
  const getVariantBackground = () => {
    switch (variant) {
      case 'primary':
        return {
          background: OPENFINANCE_THEME.gradients.primary
        };
      case 'accent':
        return {
          background: OPENFINANCE_THEME.gradients.accent
        };
      case 'secondary':
        return {
          borderColor: OPENFINANCE_THEME.colors.border
        };
      case 'outline':
        return {
          borderColor: OPENFINANCE_THEME.colors.primary500,
          color: OPENFINANCE_THEME.colors.primary500
        };
      default:
        return {};
    }
  };
  const radiusMap = {
    sm: OPENFINANCE_THEME.radius.sm,
    md: OPENFINANCE_THEME.radius.md,
    lg: OPENFINANCE_THEME.radius.md
  };
  return <button className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${className}`} style={{
    ...getVariantBackground(),
    borderRadius: radiusMap[size],
    fontFamily: OPENFINANCE_THEME.fonts.body
  }} disabled={disabled || isLoading} {...props} data-id="element-1574">
      {isLoading ? <div className="flex items-center gap-2" data-id="element-1575">
          <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-1576" />
          <span data-id="element-1577">Loading...</span>
        </div> : children}
    </button>;
}